// About.js
import React from "react";

const About = () => {
  return (
    <section id="about" className="bg-slate-50 py-16 rounded-2xl shadow-sm">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-4xl font-bold text-slate-900 mb-6">
          Wireless Communications &amp; Reinforcement Learning
        </h2>

        <p className="text-lg text-slate-700 mb-6">
          I am currently pursuing a Ph.D. in Electrical and Computer
          Engineering at New York Institute of Technology, with a research focus
          on wireless communication systems and reinforcement learning. My
          current work centers on dynamic resource allocation in multi-cell
          networks, where I use learning-based methods to design spectrum- and
          energy-efficient communication strategies under realistic
          constraints.
        </p>

        <p className="text-lg text-slate-700">
          Previously, I worked on deep learning–based channel estimation for
          RIS-assisted communication systems and end-to-end RIS system design at
          Xi’an Jiaotong University, as well as transmitter identification and a
          range of physical-layer projects involving SISO, MIMO, digital signal
          processing, and FPGA-based implementations. Across these projects, my
          long-term goal is to bridge signal processing and machine learning to
          build intelligent and scalable wireless networks.
        </p>
      </div>
    </section>
  );
};

export default About;
